import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useStyles from '../ContactCell.style';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';
import { green, red } from '@material-ui/core/colors';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { createBundle, removeBundleItem } from 'redux/actions/Movies';

const DownloadItemCell = ({ movie, movieType, choiseList }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const parent = params.get('p');

  const handleAddList = () => {
    const item = {
      parent_download_item_id: parent,
      download_item_id: movie.id,
      order: 0,
    };
    dispatch(createBundle(item));
  };

  const handleRemoveList = () => {
    dispatch(removeBundleItem(movie.id));
  };

  return (
    <TableRow className={classes.tableRowRoot}>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Typography className={classes.titleRoot} component="div" variant="h4">
            {choiseList === true ? movie.movie.name : movie.download_item_movie.name}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Typography className={classes.titleRoot} component="div" variant="h4">
            {choiseList === true ? movie.quality : movie.download_item.quality}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        {choiseList === true ? (
          <Tooltip title="اضافه کردن">
            <IconButton size="small" target="_blank" onClick={handleAddList}>
              <Add style={{ color: green[500] }} />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="حذف کردن">
            <IconButton size="small" target="_blank" onClick={handleRemoveList}>
              <Remove style={{ color: red[500] }} />
            </IconButton>
          </Tooltip>
        )}
      </TableCell>
    </TableRow>
  );
};

export default DownloadItemCell;

DownloadItemCell.prototype = {
  contact: PropTypes.object.isRequired,
  onShowContactDetail: PropTypes.func,
};
